<script lang="ts">
  import { Input, Label } from "sveltestrap";
  import type { Diligence } from "../../../Model/Diligence";
  import { usersService,} from "../../../services";
  import { dateInputFormatter, dateTimeInputFormatter } from "../../../services/Functions";
  import type { User } from "../../../Model/User";
  import type { PoliceManifestation } from "../../../Model/PoliceManifestation";
  import type { Writable } from "svelte/store";
  import { getContext } from "svelte";

  export let diligence: Diligence;

  const policeManifestation: Writable<PoliceManifestation> = getContext('policeManifestationInitial');

  let offset: number = 0;
  let limit: number = 179;
  let searchFilter = null;

  let users: User[];

  let date: string;
  let time: string;
  let dateCita: string;
  let timeCita: string;

  $: loadpoliceManifestation(diligence);
  $: loadUsers();
  async function loadUsers() {
    let opts = {
      offset: offset,
      limit: limit,
      filters: {
        search: searchFilter,
      },
    };
    try {
      users = await usersService.findUsers(opts);
    } catch (err) {}
  }

  async function loadpoliceManifestation(dilig: Diligence) {
    if ($policeManifestation) {
      date = dateInputFormatter($policeManifestation.dateCreated);
      time = dateTimeInputFormatter($policeManifestation.dateCreated);
      dateCita = dateInputFormatter($policeManifestation.dateAppointment);
      timeCita = dateTimeInputFormatter($policeManifestation.dateAppointment);
    }
  }

  // async function save() {
  //   try {
  //     await policeManifestationService.savePoliceManifestation(policeManifestation);
  //     success("Datos guardados con exito");
  //   } catch (err) {
  //     error("Comprueba los campos");
  //   }
  // }

  function getUser(): string {
    let user: User = JSON.parse(localStorage.getItem("current_user"));
    return user.id;
  }

  function onHandleChange() {
    policeManifestation.update(manifest => {
      manifest.dateCreated = new Date(date + "T" + time + ":00.000Z");
      manifest.dateAppointment = new Date(dateCita + "T" + timeCita + ":00.000Z");
      return manifest;
    })

  }
</script>

{#if $policeManifestation }
  <div class="row mt-3">
    <div class="col-12 col-md-6 mb-3">
      <Label for="victim">Policia</Label>
      <div class="input-group">
        {#if users}
          <select class="form-select" bind:value={$policeManifestation.userId}>
            {#each users as usr}
              <option value={usr.id}> {usr.name} </option>
            {/each}
          </select>
        {/if}
      </div>
    </div>
    <div class="col-12 mb-3">
      <div class="row">
        <div class="col-12 col-sm-3">
          <Label for="mark">Fecha Manif.</Label>
          <Input type="date" 
            on:change={onHandleChange} 
            bind:value={date} 
          />
        </div>
        <div class="col-12 col-sm-3">
          <Label for="time">Hora Manif.</Label>
          <Input
            type="time"
            id="time"
            on:change={onHandleChange}
            bind:value={time}
          />
        </div>
        <div class="col-12 col-sm-3">
          <Label for="mark">Fecha Cita</Label>
          <Input
            type="date"
            on:change={onHandleChange}
            bind:value={dateCita}
          />    
        </div>
        <div class="col-12 col-sm-3">
          <Label for="time">Hora Cita</Label>
          <Input
            type="time"
            id="time"
            on:change={onHandleChange}
            bind:value={timeCita}
          />
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12 col-md-12 mb-3">
      <Label for="mark">Manifectación</Label>
      <Input
        type="textarea"
        rows={6}
        bind:value={$policeManifestation.manifestation}
      />
    </div>

    <div class="col-12 col-md-12 mb-3">
      <Label for="mark">Presenta</Label>
      <Input
        type="textarea"
        rows={6}
        bind:value={$policeManifestation.present}
      />
    </div>
    <div class="col-12 col-md-12 mb-3">
      <Label for="mark">Entrega</Label>
      <Input
        type="textarea"
        rows={6}
        bind:value={$policeManifestation.delivery}
      />
    </div>
  </div>
{/if}
